import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { Match } from '../../../../database.schema';

const RESULT = ['beat', 'lost to', 'halved'];
const RESULT_MARGIN = ['1 up', '2 up', '2 & 1', '3 & 1', '3 & 2', '4 & 2', '4 & 3', '5 & 4', '6 & 5', '7 & 6', '8 & 7', '9 & 8', '10 & 8'];
const ResultWrapper = styled.div`
  margin: 0.5rem 0.25rem;
  text-align: center;
  select {
    height: 1.5rem;
  }
`;
const Margin = styled.div`
  margin: 0.25rem 0 0;
`;
const getMatchResultText = (match: Match): string => {
  const team1Points = match.team1.points;
  const team2Points = match.team2.points;

  if (team1Points === 0 && team2Points === 0) {
    return '';
  }
  switch (team1Points) {
    case 1: {
      return 'beat';
    }
    case 0: {
      return 'lost to';
    }
    case 0.5: {
      return 'halved';
    }
    default: {
      return '';
    }
  }
};

type MatchResultEntryProps = {
  matchIndex: number;
  match: Match;
  onMatchResultChange: (matchResult: string, matchIndex: number) => void;
  onMatchMarginChange: (matchMargin: string, matchIndex: number) => void;
};

export const SetMatchResult: FC<MatchResultEntryProps> = ({ matchIndex, match, onMatchResultChange, onMatchMarginChange }): JSX.Element => {
  const [result, setResult] = useState<string>(getMatchResultText(match));
  const [margin, setMargin] = useState<string>(match.resultMargin ?? '');

  return (
    <ResultWrapper>
      <div>
        <select
          name={`team-result-${matchIndex}`}
          data-testid={`team-result-${matchIndex}`}
          value={result}
          onChange={(event) => {
            setResult(event.target.value);
            onMatchResultChange(event.target.value, matchIndex);
          }}
        >
          <option value={''}>Result...</option>
          {RESULT.map((resultWord) => (
            <option key={resultWord} value={resultWord}>
              {resultWord}
            </option>
          ))}
        </select>
      </div>
      <Margin>
        <select
          name={`team-result-margin-${matchIndex}`}
          data-testid={`team-result-margin-${matchIndex}`}
          value={margin}
          onChange={(event) => {
            setMargin(event.target.value);
            onMatchMarginChange(event.target.value, matchIndex);
          }}
        >
          <option value="">By...</option>
          {RESULT_MARGIN.map((result) => (
            <option key={result} value={result}>
              {result}
            </option>
          ))}
        </select>
      </Margin>
    </ResultWrapper>
  );
};
